module.exports = __webpack_public_path__ + "static/assets/7a78587dd81a44208279a7cf1a34025c.svg";